import { render } from "./1.HeroSection.vue?vue&type=template&id=faddebb2&scoped=true"
import script from "./1.HeroSection.vue?vue&type=script&lang=js"
export * from "./1.HeroSection.vue?vue&type=script&lang=js"

import "./1.HeroSection.vue?vue&type=style&index=0&id=faddebb2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-faddebb2"]])

export default __exports__